import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jiance4",
  "use": "icon-jiance4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiance4\"><path d=\"M456 708c-6.3 0-12.7-2.1-17.9-6.5-11.9-9.9-13.5-27.6-3.6-39.4l113.7-136.4-129.1-43c-8.8-3-15.5-10-18-18.9-2.6-8.9-0.5-18.5 5.4-25.6l140-168c9.9-11.8 27.6-13.4 39.4-3.6 11.9 9.9 13.5 27.6 3.6 39.4L475.8 442.4l129.1 43c8.8 3 15.5 10 18 18.9 2.6 8.9 0.5 18.5-5.4 25.6l-140 168C472 704.6 464 708 456 708z\" p-id=\"2137\" /><path d=\"M512 120l336 145.7v188.7c0 304.3-257.2 420.9-336 449.4-78.8-28.5-336-145.2-336-449.4l0.2-189.3L512 120m0-56c-7.5 0-15 1.5-22.1 4.6l-336 145.3c-20.6 8.9-33.9 29.3-33.9 51.9v188.7c0 344.2 294.3 473.7 372.9 502.1 6.3 2.3 12.7 3.4 19.1 3.4s12.8-1.1 19.1-3.4C609.7 928.2 904 798.7 904 454.5V265.8c0-22.6-13.4-43-33.9-51.9l-336-145.3C527 65.5 519.5 64 512 64z\" p-id=\"2138\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-jiance4.svg
// module id = fTMr
// module chunks = 120